import {
  CalendarIcon,
  CheckIcon,
  ClockIcon,
  XIcon,
} from "@heroicons/react/outline";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SessionModalApologize from "../modal/SessionModalApologize";
import RequestsModel from "../../api/models/RequestsModel";
import moment from "moment";
import ApiDateParser from "../../helpers/parsers/apiDateParser";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
type OutGoingRequestCardCardProps = {
  request?: RequestsModel | null;
  changeRequestStatus?: (key1: boolean, key2: number | string) => void;
};
export default function NewRequestCard(props: OutGoingRequestCardCardProps) {
  const { request, changeRequestStatus } = props;
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [open, setOpen] = useState<boolean>(false);
  return (
    <>
      <div className="flex flex-col gap-2 pb-4 border-b border-gray-200 ">
        <div className="flex items-center justify-end w-full">
          <p className="text-sm text-gray-400">
            {" "}
            {moment(request?.createdAt).fromNow(true)}
          </p>
        </div>
        <div className="flex flex-col justify-between w-full gap-3 sm:gap-0 sm:flex-row">
          <div className="relative flex items-center gap-1 space-x-3">
            <div className="flex-shrink-0">
              <UserProfilePictureAvatar
                className="w-10 h-10 rounded-full"
                profilePictureUrl={request?.user?.profile_picture_url}
                alt=""
              />
            </div>
            <div className="flex-1 min-w-0">
              <a href="#" className="focus:outline-none">
                <span className="absolute inset-0" aria-hidden="true" />
                <p className="text-lg font-semibold text-gray-500">
                  {request?.user?.fullNameWithoutMiddle}
                </p>
              </a>
            </div>
          </div>
          <div className="flex flex-row items-center gap-3">
            <button
              type="button"
              className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 bg-white border border-red-600 rounded-md shadow-sm hover:text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
              onClick={() =>
                !!changeRequestStatus &&
                changeRequestStatus(false, request?.id ?? "")
              }
            >
              <XIcon className="w-5 h-5 " aria-hidden="true" />
              {t("refused")}
            </button>
            <button
              type="button"
              className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2"
              onClick={() =>
                !!changeRequestStatus &&
                changeRequestStatus(true, request?.id ?? "")
              }
            >
              <CheckIcon className="w-5 h-5 " aria-hidden="true" />
              {t("approved")}
            </button>
          </div>
        </div>
        <div className="flex flex-col w-full gap-2">
          <div className="flex flex-row justify-between w-full ">
            <p className="text-xl font-medium leading-8 text-gray-700">
              {t("session")} # {request?.scheduleSlot?.id}
            </p>
            <button
              onClick={() => setOpen(true)}
              className="text-sm font-medium underline text-brandblue-600 "
            >
              {t("reasonShow")}
            </button>
          </div>
          <div className="flex flex-row items-center w-full gap-4 ">
            <p className="flex  flex-row gap-[6px] text-gray-400 text-sm font-medium ">
              <CalendarIcon className="w-5 h-5" />
              {moment(request?.date).format("dddd M/D")}
            </p>
            <p className="flex  flex-row gap-[6px] text-gray-400 text-sm font-medium ">
              <ClockIcon className="w-5 h-5" />
              {ApiDateParser.parse(request?.scheduleSlot?.start_time).format(
                "hh:mm A"
              )}
            </p>
          </div>
        </div>
      </div>
      <SessionModalApologize
        open={open}
        setOpen={(newValue: boolean) => setOpen(false)}
        request={request}
      />
    </>
  );
}
